<template>
  <div class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="content-body table-wrapper">
      <div class="block">
        <div class="quotes-finder--filter" style="display: flex; flex-flow: row; justify-content: flex-start; gap: 10px;">
          <Input v-model="filter.title" :placeholder="$t('quote.search_from_title_placeholder')" style="flex: 1 1 0px"></Input>
          <ProductSelect v-model="filter.product_id" style="flex: 1 1 0px"></ProductSelect>
          <AccountSelect v-model="filter.customer_id" style="flex: 1 1 0px" :placeholder="$t('quote.search_customer_placeholder')" clearable></AccountSelect>
          <Button type="primary" @click="handleFilter">{{ $t('quote.search_go') }}</Button>
        </div>
        <div style="margin: 20px 0"></div>
        <vxe-toolbar>
          <template #buttons>
            <div class="text-align-right">
              <Button type="primary" :to="{ name: `menu.quote.new_${quoteMethod}_quotes_group` }">{{ $t(`menu.quote.new_${quoteMethod}_quotes_group`) }}</Button>
            </div>
          </template>
        </vxe-toolbar>
        <vxe-table size="mini" :data="quoteGroupList.data" :loading="loading" resizable border>
          <vxe-table-column type="seq" width="40" align="center"></vxe-table-column>
          <vxe-table-column field="title" :title="$t('quote.info.title')" min-width="280"></vxe-table-column>
          <vxe-table-column field="expires_at" :title="$t('quote.info.expires_date')" width="110" align="right">
            <template #default="{ row }">{{ moment(row.expires_at).format('YYYY-MM-DD') }}</template>
          </vxe-table-column>
          <vxe-table-column field="product.product_name" :title="$t('quote.info.product_name')" min-width="180"></vxe-table-column>
          <vxe-table-column field="customer.name" :title="$t('quote.info.customer')" width="200"></vxe-table-column>
          <vxe-table-column :title="$t('quote.info.owner')" width="150">
            <template #default="{ row }">{{ row.people ? `${row.people.fullname_cn} (${row.people.fullname_en})` : '' }}</template>
          </vxe-table-column>
          <vxe-table-column field="created_at" :title="$t('quote.info.created')" align="right" width="110">
            <template #default="{ row }">{{ moment(row.created_at).format('YYYY-MM-DD') }}</template>
          </vxe-table-column>
          <vxe-table-column :title="$t('order.actions')" width="130" align="center">
            <template #default="{ row }">
              <Button type="text" @click="handleItemEditClick(row)" size="small">{{ $t('edit') }}</Button>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager
            border
            icon-prev-page="fa fa-angle-left"
            icon-jump-prev="fa fa-angle-double-left"
            icon-jump-next="fa fa-angle-double-right"
            icon-next-page="fa fa-angle-right"
            icon-jump-more="fa fa-ellipsis-h"
            :loading="loading"
            :current-page="pager.current_page"
            :page-size="pager.per_page"
            :total="pager.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handlePageChange">
        </vxe-pager>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductSelect } from '@/view/product/components'
import { AccountSelect } from '@/view/account/components'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: "QuoteGroups",
  components: {
    ProductSelect,
    AccountSelect
  },
  data () {
    return {
      loading: false,
      pager: {
        page_size: 15,
        page: 1
      },
      filter: {},
      items: []
    }
  },
  computed: {
    ...mapGetters(['quoteGroupList']),
    quoteMethod () {
      return this.$route.path.split('/').splice(3, 1)
    },
    pageTitle () {
      const name = this.$route.path.split('/').splice(3, 1)
      document.title = this.$t(`menu.quote.${name}_quotes_group_list`)
      return document.title
    }
  },
  mounted () {
    this.getQuoteGroups()
  },
  methods: {
    ...mapActions([
      'getQuoteGroupList'
    ]),
    moment,
    getQuoteGroups () {
      this.loading = true
      this.getQuoteGroupList(this.buildQuery())
        .then(resp => {
          this.pager = (({ per_page, current_page, total }) => ({ per_page, current_page, total }))(resp.data.meta)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleFilter () {
      this.getQuoteGroups()
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.pager.page = currentPage
      this.pager.per_page = pageSize
      this.getQuoteGroups()
    },
    handleItemEditClick (row) {
      this.$router.push({ name: 'menu.quote.edit_estimate_quotes_group', params: { id: row.id } })
    },
    buildQuery () {
      this.filter = Object.assign({}, this.filter, { type: this.quoteMethod })
      let search = Object.entries(this.filter).filter(([_, v]) => v).map((e) => {
        return e.join(':')
      }).join(';')

      return Object.assign({}, { search: search, searchJoin: 'and' }, this.pager)
    }
  },
  watch: {
    quoteMethod () {
      this.getQuoteGroups()
    }
  }
}
</script>
